module.exports = __webpack_public_path__ + "static/media/survey_header.2c483590.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/survey_header.png
// module id = 439
// module chunks = 1